import * as React from "react";
const SvgNavigationMenu = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.69 1.871V3.38h20.62V1.87H12Zm0 9.381v1.496h20.62v-1.496H12Zm0 9.37V22.128h20.62V20.62H12Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgNavigationMenu;
